import React from 'react'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function GstEwayBillApi() {
    return (
        <div>
            <div className='pt-5' style={{ background: 'linear-gradient(-135deg, rgb(0 170 184) 0px, rgb(23 167 142) 100%)' }}>
                <img className='img-fluid shadow-0' src="./assets/images/gst-api-banner.png" alt="" />
            </div>
            <div className="bg-light">
                <div className="container mt-5 section-advantage-intelligence-insight p-3">
                    <h2 className='text-center'>GST Return Filing Functions Available as
                        GST Software API</h2>
                    <div className="card shadow mt-5 p-4">
                        <div className="row">
                            <div className="col-sm-12 col-md-3">
                                <ul>
                                    <li><p>GSTR-1</p></li>
                                    <li><p>GSTR-2A</p></li>
                                    <li><p>GSTR-3B</p></li>
                                    <li><p>GSTR-9</p></li>
                                </ul>
                            </div>
                            <div className="col-sm-12 col-md-5">
                                <ul>
                                    <li><p>Cash ITC Balance</p></li>
                                    <li><p>Cash Ledger details</p></li>
                                    <li><p>ITC Ledger details</p></li>
                                    <li><p>Liability ledger details for Return Liability</p></li>
                                </ul>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <ul>
                                    <li><p>Other then Return Ledger</p></li>
                                    <li><p>RetLiab Balance</p></li>
                                    <li><p>Search Taxpayer</p></li>
                                    <li><p>View and Track Return status</p></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container mt-5 section-advantage-intelligence-insight p-3">
                <h2 className='text-center'>E-Way Bill APIs</h2>
                <p className='text-center text-muted'>Develop your own E-Way application by using GSTrobo E-Way Bill APIs</p>
                <div className="card shadow mt-5 p-4">
                    <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <ul>
                                <li><p>Generate E-way Bill</p></li>
                                <li><p>Update PART B</p></li>
                                <li><p>Cancel E-way Bill</p></li>
                                <li><p>Update Transporter</p></li>
                            </ul>
                        </div>
                        <div className="col-sm-12 col-md-4">
                            <ul>
                                <li><p>Reject E-way Bill</p></li>
                                <li><p>Extend Validity</p></li>
                                <li><p>Consolidated E-way Bill</p></li>
                                <li><p>Add Multi Vehicle</p></li>
                            </ul>
                        </div>
                        <div className="col-sm-12 col-md-4">
                            <ul>
                                <li><p>Get E-way Bill Details</p></li>
                                <li><p>Get GSTIN</p></li>
                                <li><p>Get HSN</p></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-light">
                <div className="container mt-5 section-advantage-intelligence-insight p-3">
                    <h2 className='text-center'>E-Invoicing APIs</h2>
                    <p className='text-center text-muted'>Build your own E-invoicing application using E-invoicing APIs</p>
                    <div className="card shadow mt-5 p-4">
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <ul>
                                    <li><p>E-Invoicing APIs Features</p></li>
                                    <li><p>Cancel IRN</p></li>
                                </ul>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <ul>
                                    <li><p>Authentication</p></li>
                                    <li><p>Get E-invoice Details</p></li>
                                </ul>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <ul>
                                    <li><p>Generate IRN</p></li>
                                    <li><p>Get GSTIN Details</p></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container section-5-gst-software mt-5 p-3 text-center">
                <h2>Key Features of GST EWB & E-Invoicing APIs</h2>
                <div className="section-5-gst-software-cards mt-5 p-3">

                    <div className="row">
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3 w-25' src="./assets/images/invoice.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>GSTN Verification : check GSTN taxpayer details either through number, name or PAN</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/tax (1).png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>HSN Search: find latest HSN code and associated tax rate</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/integration.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>GST Return Status: check return foiling status</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/cloud-based.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>GST Calculator: Calculate GST on goods and services</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/high-security.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>CFO dashboard on Mobile</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div style={{ minHeight: '270px' }} className="card shadow mt-4 p-3 align-items-center">
                                <div className="card-head">
                                    <img className='img-fluid w-50 m-3' src="./assets/images/data-management.png" alt="" />
                                </div>
                                <div className="card-body ">
                                    <p>API utilization on Mobile</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container gstrobo-section-3 bg-light mt-5 text-center pb-5">
                <h1 className='pt-5'><span style={{ color: '#f43f47' }}>GST</span> Products</h1>
                <p className='text-muted'>Ensuring Compliance, Reliability & Efficiency</p>
                <div className="gstrobo-cards">
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/invoice.png" alt="" />
                        <h4 className='mt-3'>GST Software</h4>
                        <Link to='/gst-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/real-time-goods.png" alt="" />
                        <h4 className='mt-3'>E-Way Bill Software</h4>
                        <Link to='/e-way-bill-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/one-click-icon.png" alt="" />
                        <h4 className='mt-3'>E-Invoicing Software</h4>
                        <Link to='/e-invoicing-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/api.png" alt="" />
                        <h4 className='mt-3'>GST & E-Way Bill API</h4>
                        <Link to='/gst-e-way-bill-api'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/reconcile.png" alt="" />
                        <h4 className='mt-3'>Intelligence Insight</h4>
                        <Link to='/intelligence-insight'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/ledger.png" alt="" />
                        <h4 className='mt-3'>Value Added Tools</h4>
                        <Link to='/value-added-tools'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                </div>
            </div>

        </div>
    )
}
